// contexts/CategoriesContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchCategories, createCategory, deleteCategory } from '../../api/categoriesApi';

const CategoriesContext = createContext();

export function CategoriesProvider({ children }) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = async () => {
  try {
    setLoading(true);
    const data = await fetchCategories();
    
    // Create virtual Recent category
    const virtualRecent = {
      id: 'recent',
      name: 'Recent',
      parent_id: null,
      is_special: true,
      is_virtual: true,
      sort_order: -1 // This puts it first in the list
    };
    
    // Add virtual category to the beginning of the list
    const allCategories = [virtualRecent, ...data];
    
    setCategories(allCategories);
    setError(null);
  } catch (err) {
    setError('Failed to load categories');
    console.error('Error loading categories:', err);
  } finally {
    setLoading(false);
  }
};

  const addCategory = async (name) => {
    try {
      const newCategory = await createCategory(name);
      setCategories(prev => [...prev, newCategory]);
      return newCategory;
    } catch (err) {
      setError('Failed to create category');
      throw err;
    }
  };

    const removeCategory = async (categoryId) => {
      try {
        await deleteCategory(categoryId);
        setCategories(prev => prev.filter(cat => cat.id !== categoryId));
      } catch (err) {
        setError('Failed to delete category');
        throw err;
      }
    };

  const removeCategoryFromState = (categoryId) => {
  setCategories(prev => prev.filter(cat => cat.id !== categoryId));
};

const reorderCategories = (reorderedCategories) => {
  setCategories(reorderedCategories);
};

  const value = {
    categories,
    loading,
    error,
    addCategory,
    removeCategory,
    removeCategoryFromState,
    reorderCategories,
    refreshCategories: loadCategories
  };

  return (
    <CategoriesContext.Provider value={value}>
      {children}
    </CategoriesContext.Provider>
  );
}

export function useCategories() {
  const context = useContext(CategoriesContext);
  if (!context) {
    throw new Error('useCategories must be used within a CategoriesProvider');
  }
  return context;
}